import React from "react";
import {Box, Button, IconButton, inputBaseClasses, Stack, Typography} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import dayjs from "@onair/utils/dayjs";
import { Field, schemaHelper } from "@onair/minimal-ui/hook-form";
import { WizardSchemaType } from "../../index";
import {useFieldArray, UseFormReturn, useWatch} from "react-hook-form";
import { Iconify } from "@onair/minimal-ui/iconify";

interface Props {
	methods: UseFormReturn<WizardSchemaType>;
}

const AgendaContent = ({ methods }: Props) => {
	const { control, watch, setValue } = methods;

	const { fields, append, remove } = useFieldArray({
		control,
		name: "stepResource.agendas",
	});

	const startDate = useWatch({
		name: "stepTimelineAndPricing.startDate",
		control
	});
	const endDate = useWatch({
		name: "stepTimelineAndPricing.endDate",
		control
	});

	return (
		<Stack spacing={2}>
			{fields.map((field, index) => {
				return (
					<Box p={2} bgcolor="grey.100" borderRadius={2} key={field.id}>
						<Stack spacing={2}>
							<Stack
								direction="row"
								justifyContent="space-between"
								alignItems="center"
							>
								<Stack direction="row" spacing={2}>
									<Box
										borderLeft="4px solid"
										borderColor="primary.main"
										sx={{
											borderRadius: 100,
										}}
									></Box>
									<Typography variant="subtitle2">
										Lịch trình {index + 1}
									</Typography>
								</Stack>

								<IconButton
									size="small"
									color="error"
									onClick={() => remove(index)}
								>
									<DeleteForeverIcon />
								</IconButton>
							</Stack>
							<Stack direction="row" spacing={2}>
								<Field.DateTimePicker
									name={`stepResource.agendas.${index}.startDate`}
									label="Thời gian bắt đầu"
									slotProps={{
										textField: {
											required: true,
										},
									}}
									sx={{
										[`& .${inputBaseClasses.root}`]: {
											backgroundColor: "white",
										}
									}}
									disablePast
									minDateTime={dayjs(startDate)}
									maxDateTime={dayjs(endDate)}
								/>
								<Field.DateTimePicker
									name={`stepResource.agendas.${index}.endDate`}
									label="Thời gian kết thúc"
									slotProps={{
										textField: {
											required: true,
										},
									}}
									sx={{
										[`& .${inputBaseClasses.root}`]: {
											backgroundColor: "white",
										}
									}}
									disablePast
									minDateTime={dayjs(startDate)}
									maxDateTime={dayjs(endDate)}
								/>
							</Stack>
							<Stack direction="row" spacing={2}>
								<Field.UploadAvatar
									name={`stepResource.agendas.${index}.thumbnail`}
									maxSize={3145728}
									accept={{
										"image/jpeg": [],
										"image/jpg": [],
										"image/png": [],
									}}
									sx={{
										"& svg": {
											height: 12,
											width: 12,
										},
										"& span": {
											fontSize: "6px",
											textAlign: "center",
										},
										"& .mnl__image__root": {
											borderRadius: 0,
										},
										height: 54,
										width: 54,
										padding: 0,
									}}
									onDelete={() =>
										setValue(`stepResource.agendas.${index}.thumbnail`, null, {
											shouldValidate: true,
										})
									}
								/>
								<Field.Text
									name={`stepResource.agendas.${index}.title`}
									label="Tiêu đề"
									sx={{
										[`& .${inputBaseClasses.root}`]: {
											backgroundColor: "white",
										}
									}}
								/>
							</Stack>

							<Field.Text
								name={`stepResource.agendas.${index}.content`}
								label="Nội dung"
								rows={3}
								multiline
								sx={{
									[`& .${inputBaseClasses.root}`]: {
										backgroundColor: "white",
									}
								}}
							/>
						</Stack>
					</Box>
				);
			})}

			<Stack
				justifyContent="space-between"
				spacing={1.5}
				alignItems="center"
				direction="row"
			>
				<Box width="35%" height="1px" bgcolor="rgba(0, 80, 255, 0.48)" />
				<Button
					variant="outlined"
					color="primary"
					sx={{
						borderRadius: 100,
						flexGrow: 1,
						width: "40%",
					}}
					onClick={() =>
						append({
							title: "",
							startDate: null,
							endDate: null,
						})
					}
					startIcon={<Iconify icon="eva:plus-circle-outline" width={20} />}
				>
					Thêm mới
				</Button>
				<Box width="35%" height="1px" bgcolor="rgba(0, 80, 255, 0.48)" />
			</Stack>
		</Stack>
	);
};

export default AgendaContent;
